import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-image',
  templateUrl: './sample-image.component.html',
  styleUrls: ['./sample-image.component.scss']
})
export class SampleImageComponent implements OnInit {
  @Input() block: any;
  public imageSrc: string = "";
  public imageAlt: string = "";
  public domainWebsite = environment.urlApi;

  constructor(private helpersService: HelpersService) {}
  
  ngOnInit(): void {
    if(this.block && this.block.immagine){
      this.imageSrc = this.domainWebsite + this.helpersService.retrieveImage(this.block.immagine, "src");
      this.imageAlt = this.helpersService.retrieveImage(this.block.immagine, "alt");
    }
  }
}
